/* eslint-disable max-len, no-console, no-unused-vars, capitalized-comments */
/* eslint-disable react/no-unescaped-entities, jsx-a11y/no-autofocus */
/* eslint-disable */
import * as yup from "yup";
import { Alert, Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useAuth } from "../services/eqqo.auth.service";
import { useCallback, useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import Helmet from "react-helmet";
import { Link, useLocation, useNavigate } from "react-router-dom";

import loginMFACode from "./getMFACodesMutation";
import { useMutation } from "react-query";
import { mfaValidationSchema as validationSchema } from "../services/eqqo.auth.service";

const SignInConfirmation = () => {
	const { login, user } = useAuth();
	const navigate = useNavigate();
	const { state } = useLocation();
	const {
		mutateAsync: resendMFACode
	} = loginMFACode(useMutation);

	const [validCode, setValidCode] = useState(false);
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);
	const [successMessage, setSuccessMessage] = useState(null);

	const inputRef = useRef();
	useEffect(() => {
		inputRef.current.focus();

		if ( !state?.username ) {
			navigate('/sign-in');
		}
	}, []);

	const initialValues = {
		signInCode: ""
	};

	const handleFormSubmit = useCallback(async (values) => {
		setLoading(true);
		setErrorMessage(null);
		
		const {redirect, ...loginCreds} = state;

		const input = {
			...loginCreds,
			mfaCode: values.signInCode
		};

		login(input)
		.then((user) => {
			if (user.weqProfileId) {
				if ( redirect) {
					navigate(redirect);
				} else {
					navigate("/profile/dashboard");
				}
			} else {
				navigate("/sign-up/questionnaire");
			}
		})
		.catch(async (error) => {
			console.log(error);
			setErrorMessage(error.message);
			setSuccessMessage(null);
			setValidCode(false);

			inputRef?.current?.select();
		})
		.finally(() => {
			setLoading(false);
		});
	}, [state]);

	const handleResendCode = useCallback(async () => {
		setLoading(true);
		// Logic to resend the MFA code

		if ( !state.username ) {
			navigate('/sign-in');
		}

		try {
			await resendMFACode(state);
			setSuccessMessage("MFA code resent successfully. Please check your email.");
			setErrorMessage(null);
			inputRef.current.select();
		} catch (error) {
			setErrorMessage(error.message);
		}

		setLoading(false);
	}, [state]);

	useEffect(() => {
		if (!validCode) { return };
		if (user.weqProfiles === null) {
			navigate("/sign-up/questionnaire");
		} else {
			navigate("/profile/dashboard");
		}
	}, [validCode])

	return (
		<Row as="main" className="sign-up">
			<Helmet>
				<title>
					{"Sign In to Your EQQO Account"}
				</title>
			</Helmet>

			<Col className="create-account flow" fluid="true">
				<div className="d-flex flex-column align-items-center flex-md-row justify-content-md-between wrapper w-100">
					<img
						alt="LOGO" className="logo" height="152" src="/eqqo_logo_blue.png"
						width="472"
					/>
				</div>
				<Container className="bg-white flow wrapper">
					<h1>Sign In to Your EQQO Account</h1>
					<p>
						Please enter the code we sent to your email.
					</p>

					{errorMessage
						? (
							<Alert variant="danger" className="my-3 d-flex align-items-center">
								<span className="flex-fill">{errorMessage}</span>
								<Button
									disabled={loading}
									variant="danger"
									onClick={handleResendCode}
								>
									{loading ? <Spinner animation="border" size="sm" /> : "Resend Code"}
								</Button>
							</Alert>
						)
						: null}
					{successMessage
						? (
							<Alert variant="success" className="my-3 d-flex align-items-center">
								<span className="flex-fill">{successMessage}</span>
							</Alert>
						)
						: null}
					<Formik
						initialValues={initialValues}
						onSubmit={handleFormSubmit}
						validationSchema={validationSchema}
					>
						{({
							errors,
							handleBlur,
							handleChange,
							handleSubmit,
							touched,
							values
						}) => (
							<Form noValidate onSubmit={handleSubmit}>
								<Form.Label htmlFor="signInCode">Sign In Code</Form.Label>
								<Form.Control
									autocomplete="one-time-code"
									isInvalid={Boolean(errors.signInCode)}
									maxLength="6"
									name="signInCode"
									onBlur={handleBlur}
									onChange={handleChange}
									ref={inputRef}
									required
									type="text"
									value={values.signInCode}
								/>
								<Form.Control.Feedback type="invalid">
									{touched.signInCode && errors.signInCode ? <p className="my-0">{errors.signInCode}</p> : null}
								</Form.Control.Feedback>
								<Button className="btn-gradient mt-4 w-100" type="submit">
									{loading ? <Spinner animation="border" size="sm" /> : "Verify Code"}
								</Button>
							</Form>)}
					</Formik>
					<div className="text-center">
						<Link to="/sign-in">&larr; Back to Sign In</Link>
					</div>
				</Container>
			</Col>
		</Row>
	);
};

export default SignInConfirmation;
